import React, { Component } from 'react';
import { Modal, Button, Table, Loader, Dimmer, Form, TextArea, Input, Label } from 'semantic-ui-react';
import { get, del, post, put } from '../services/RestUtilities';
import { Link } from 'react-router-dom';
import ToastUtilities from './ToastUtilities';

export default class ApplicationReview extends Component {

    constructor(props) {
        super(props);

        this.state = {
            reviewResponse: {
                userResponse: '',
                reviewType: '',
                applicationErrors: []
            },
            reviewComments: '',
            loading: false
        }
    }

    handleReviewCommentsChange = (e) => {
        this.setState({ reviewComments: e.target.value });
    }

    handleOpen = () => {
        get(`api/Application/GetApplicationReviewErrors?id=${this.props.applicationId}`)
            .then((response) => {
                this.setState({ reviewResponse: response.content, reviewComments: response.content.reviewResponse });
            });
    }

    handleReviewApplication = (accepted) => {
        this.setState({ loading: true });
        post('api/Application/ReviewApplication', {
            id: this.props.applicationId,
            comments: this.state.reviewComments,
            accepted: accepted,
            reviewType: this.state.reviewResponse.reviewType
        })
            .then((response) => {
                this.setState({ loading: false });
                if (!response.isError) {
                    window.location.reload();
                } else {
                    ToastUtilities.error(response.errorContent.errorMessage);
                }
            });
    }

    render() {
        const { reviewResponse, reviewComments, loading } = this.state;

        return (
            <Modal size='small' onOpen={this.handleOpen} trigger={this.props.trigger} closeIcon>
                <Modal.Header><Button basic icon='folder open outline' color='green' as={Link} to={`/application/${this.props.applicationId}`} /> Review Application</Modal.Header>
                <Modal.Content scrolling style={{overflowY:"auto"}}>
                    <Table compact celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Error(s)</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {reviewResponse.applicationErrors.map(error => {

                                let statusColor = 'grey';
                                if (error.status === 'Rejected') { statusColor = 'red'; }
                                if (error.status === 'Overridden') { statusColor = 'green'; }

                                return (
                                    <Table.Row key={error.id}>
                                        <Table.Cell>{error.errorMessage}</Table.Cell>
                                        <Table.Cell><Label color={statusColor} content={error.status} /></Table.Cell>
                                    </Table.Row>
                                )
                            })}
                        </Table.Body>
                    </Table>
                    
                    <Form as='div'>
                        <Form.Field>
                            <label>User response</label>
                            <TextArea
                                autoHeight
                                //https://bootstrap-vue.org/docs/components/form-textarea
                                //rows = Sets the initial minimum height (in rows)
                                rows={3}
                                //max-rows = The maximum number of lines of text. This is required for enabling the scrollbar
                                max-rows="3"
                                //no-auto-shrink = allows height to be "sticky"
                                no-auto-shrink
                                value={reviewResponse.userResponse}
                                disabled
                            />
                        </Form.Field>
                    </Form>

                    <b>Internal Notes</b>
                    <Chat id={this.props.applicationId} />

                    <Form as='div'>
                        <Form.Field>
                            <label>Reviewer comments</label>
                            <TextArea
                                autoHeight
                                placeholder='Enter comments here'
                                //https://bootstrap-vue.org/docs/components/form-textarea
                                //rows = Sets the initial minimum height (in rows)
                                rows={3}
                                //max-rows = The maximum number of lines of text. This is required for enabling the scrollbar
                                max-rows="3"
                                //no-auto-shrink = allows height to be "sticky"
                                no-auto-shrink
                                value={reviewComments}
                                onChange={this.handleReviewCommentsChange}
                                disabled={this.props.alreadyOverriden}
                            />
                        </Form.Field>
                    </Form>

                </Modal.Content>
                <Modal.Actions>
                    {this.props.alreadyOverriden ? (
                        <p>This error has already been accepted or rejected.</p>
                    ) : (
                        <div>
                            <Button color='red' loading={loading} disabled={loading} content='Reject' onClick={() => this.handleReviewApplication(false)} />
                            <Button color='green' loading={loading} disabled={loading} content='Approve' onClick={() => this.handleReviewApplication(true)} />
                        </div>
                    )}

                </Modal.Actions>
            </Modal>
        );
    }
}

class Chat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            loading: true,
            message: '',
        }
    }

    componentDidMount() {
        get(`api/Application/GetApplicationMessages/${this.props.id}`)
            .then((response) => {
                this.setState({ loading: false });
                if (!response.isError) {
                    this.setState({ messages: response.content });
                } else {
                    ToastUtilities.error(response.errorContent.errorMessage);
                }
            });
    }

    sendMessage = () => {
        if (this.state.message === '') {
            ToastUtilities.error('Message is required.');
            return;
        }
        post('api/Application/InsertApplicationMessage', {
            id: this.props.id,
            message: this.state.message
        }).then((response) => {
            if (!response.isError) {
                this.setState({ messages: response.content, message: '' });
            } else {
                ToastUtilities.error(response.errorContent.errorMessage);
            }
        });
    }

    handleMessageChange = (e) => {
        this.setState({ message: e.target.value });
    }

    render() {
        return (
            <div className='chat-container'>
                <Dimmer active={this.state.loading} inverted>
                    <Loader />
                </Dimmer>
                <Messages messages={this.state.messages} />
                <ChatInput message={this.state.message} sendMessage={this.sendMessage} onChange={this.handleMessageChange} />
            </div>
        );
    }
}

const ChatInput = props => (
    <Input type="text"
        onChange={props.onChange}
        value={props.message}
        placeholder="Write a message..."
        style={{ margin: '0.5rem' }}
        action
    >
        <input />
        <Button color='green' circular icon='arrow circle up' disabled={props.message === ''} onClick={props.sendMessage} />
    </Input>
);

class Messages extends Component {
    componentDidUpdate() {
        const objDiv = document.getElementById('messageList');
        objDiv.scrollTop = objDiv.scrollHeight;
    }

    render() {
        const messages = this.props.messages.map((message, i) => {
            return (
                <Message
                    key={i}
                    author={message.author}
                    message={message.message}
                    fromMe={message.fromMe}
                />
            );
        });

        return (
            <div className='messages' id='messageList'>
                {messages}
            </div>
        );
    }
}

const Message = props => {

    const fromMe = props.fromMe ? 'from-me' : '';

    return (
        <div className={`message ${fromMe}`}>
            <div className='author'>
                {props.author}
            </div>
            <div className='message-body'>
                {props.message}
            </div>
        </div>
    );
}
